<template>
  <b-card
    class="product-tile d-inline-flex product-listing justify-content-start"
    @click="select"
    tabindex="1"
    @keydown.enter="select"
    @keydown.space="select"
    body-class="product-tile-container"
    >
      <div class="product-tile-image">
        <BCardImg :src="getImageUrl" @error="setAltImg($event)" img-top></BCardImg>
      </div>
      <div class="product-name mt-2 mb-3">{{product.name}}</div>
      <div class="d-flex justify-content-between align-items-end">
        <div class="price d-flex ml-2 ml-sm-3 flex-sm-row text-nowrap align-self-center" :class="hasMemberDiscount || onSale ? 'flex-column' : 'flex-column-reverse'">
          <template v-if="hasMemberDiscount">
            <div class="membership-price-container">
              <div v-if="onSale" class="membership-price-tag text-left mr-3">Sale</div>
              <div v-else class="membership-price-tag text-left mr-3">Regular</div>
              <div class="membership-price" :class="{'original-price': session.has_membership}">
                {{product.price | currency(product.currency)}}
              </div>
            </div>
            <div class="membership-price-container ml-0 ml-sm-2 text-left">
              <div class="membership-price-tag">Member</div>
              <div class="membership-price">{{product.membership_price | currency(product.currency)}}</div>
            </div>
          </template>
          <template v-else-if="onSale">
            <div class="original-price align-self-center">{{product.product.msrp | currency(product.currency)}}</div>
            <div class="sale-price pl-sm-2">{{product.price | currency(product.currency)}}</div>
          </template>
          <template v-else>
            <div class="product-price">{{ product.price | currency(product.currency) }}</div>
          </template>
        </div>
        <div class="d-flex flex-column">
          <template v-if="!canBuyProduct">
            <b-button v-if="product.url"
                      block
                      type="button"
                      @click.stop="$event.stopPropagation()"
                      class="buy-now-button text-uppercase text-nowrap"
                      variant="primary"
                      :href="product.url"
                      target="_blank"
            >
              BUY NOW
            </b-button>
          </template>
          <template v-else>
            <b-button
              block
              @click.stop="buyNow(true)"
              class="buy-now-button text-uppercase text-nowrap"
              variant="primary">
              Buy Now
            </b-button>
          </template>
        </div>
      </div>
      <div v-if="onSale" class="new-onsale">Sale</div>
      <CheckoutCustomerConfirmation  @close="closePopUp" v-on:verified="customerVerified" @verificationFailed="customerVerificationFailed"
                                  v-if="showVerificationPopup"></CheckoutCustomerConfirmation>
  </b-card>
</template>

<script>
import {
  getCampaignProductImageUrl,
  setFallbackImageUrl
} from '../utils'
import { mapState, mapGetters } from 'vuex'
const CheckoutCustomerConfirmation = () => import('../components/CheckoutCustomerConfirmation')

export default {
  name: 'ProductTile',
  components: {CheckoutCustomerConfirmation},
  props: {
    product: Object
  },
  data: function() {
    return {
      showVerificationPopup: false
    }
  },
  computed: {
    ...mapState(['session', 'campaign']),
    ...mapGetters(['canLogoutSession', 'isSessionUserKnown', 'checkoutDisabled']),
    getImageUrl: function() {
      return getCampaignProductImageUrl(this.product, 'original')
    },
    onSale: function() {
      return this.product.product.msrp &&
        ((parseFloat(this.product.product.msrp) - parseFloat(this.product.price)) > Number.EPSILON)
    },
    hasMemberDiscount: function() {
      return this.product.membership_price !== null &&
        ((parseFloat(this.product.price) - parseFloat(this.product.membership_price)) > Number.EPSILON)
    },
    canBuyProduct: function() {
      return this.campaign.portal_settings &&
        this.campaign.portal_settings.allow_buy_again &&
        this.product.can_charge_customer &&
        !this.checkoutDisabled
    }
  },
  methods: {
    select: function() {
      this.$router.push({name: 'product-details', params: {id: this.product.id, slug: this.product.slug}})
    },
    setAltImg: function(event) {
      setFallbackImageUrl(event, this.product, 'original')
    },
    buyNow() {
      const item = {
        campaign_product: this.product,
        quantity: 1,
        buy_now_clicked: true
      }
      this.$store.commit('busy')
      this.$store.dispatch('set_session_started')
      this.$store.dispatch('add_cart', item)
        .then(cart => {
          this.$store.commit('ready')
          if (this.isSessionUserKnown) {
            this.customerVerified()
          } else {
            this.showVerificationPopup = true
          }
        })
        .catch(err => {
          this.$store.commit('error', err)
          this.$store.commit('ready')
        })
    },
    customerVerified: function() {
      this.showVerificationPopup = false
      this.$router.push({name: 'session-jump', params: {step: 'checkout'}})
    },
    customerVerificationFailed: function(message) {
      this.$store.commit('error', message)
      this.$router.push({name: 'session-jump', params: {step: 'checkout'}})
    },
    closePopUp: function() {
      this.showVerificationPopup = false
    }
  }
}
</script>

<style scoped>
  .price {
    font-size: 18px;
  }
  .price span {
    margin: 0 5px;
  }
  .original-price {
    text-decoration: line-through;
    color: #ff0000;
    font-weight: normal;
  }
  .product-tile .product-name {
    text-align: center;
  }

</style>
